import { useLocation } from 'react-router-dom';
import ProgressTransferContainer from 'academy-common-lib/features/certificate/components/progressTransfer/ProgressTransferContainer';
import { useAwardsByTrack } from '../../myTeamQueries';
import { useMemo } from 'react';
import getLang from '../../../../utils/getLang';
import UsageTracker from '../../../../utils/UsageTracker';
import ApiError from '../../../../components/Errors/ApiError';
import { useUserInfo } from '../../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
const ProgressTransferModal = ({
  isOpen,
  onClose
}) => {
  var _userInfo$user;
  const location = useLocation();
  const {
    awardsByTrack
  } = useAwardsByTrack();
  const {
    userInfo
  } = useUserInfo();
  const searchParams = new URLSearchParams(location.search);
  const confirmSwap = searchParams.get('confirmSwap');
  const confirmationGuid = searchParams.get('confirmationGuid');
  const shouldVerifyProgressTransfer = Boolean(confirmSwap && confirmationGuid);
  const userAwardsNames = useMemo(() => {
    if (!awardsByTrack) {
      return [];
    }
    return Object.keys(awardsByTrack).map(trackIdKey => {
      const trackId = Number(trackIdKey);
      const award = awardsByTrack[trackId];
      if (!award) {
        return null;
      }
      const language = getLang();
      const languageData = award.languageMetadata[language] || award.languageMetadata['en'] || {};
      return languageData.title;
    }).filter(Boolean);
  }, [awardsByTrack]);
  const handleTrackEvent = eventProps => {
    UsageTracker.track('teamInteraction', eventProps);
  };
  const currentUserEmail = (userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.emails) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user[0]) || '';
  return /*#__PURE__*/_jsx(ProgressTransferContainer, {
    ErrorComponent: ApiError,
    currentUserEmail: currentUserEmail,
    handleClose: onClose,
    isOpen: isOpen,
    trackEvent: eventProps => {
      if (eventProps) {
        handleTrackEvent(eventProps);
      }
    },
    userAwards: userAwardsNames,
    verify: shouldVerifyProgressTransfer
  });
};
export default ProgressTransferModal;